export default __webpack_public_path__ + "static/media/Scroller.1790ad65.svg";